var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-title"},[_c('div',{staticClass:"inner  border-primary"},[(_vm.title)?_c('strong',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('strong',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }